import { createReducer, on, Action } from '@ngrx/store';
import { modalHide, modalShow } from './actions';

export interface State {
  title: string;
  text: string;
  text2?: string;
  text3?: string;
  acceptButtonText: string;
  noShowButtonBack?: boolean;
  visible: boolean;
  actionOnAccept: () => void;
  actionOnCancel: () => void;
}

const initialState: State = {
  title: '',
  text: '',
  text2: '',
  text3: '',
  acceptButtonText: '',
  noShowButtonBack: true,
  visible: false,
  actionOnAccept: () => { },
  actionOnCancel: () => { },
};

const _modalReducer = createReducer(
  initialState,
  on(modalShow, (state: State, {
    text,
    text2,
    text3,
    title,
    noShowButtonBack,
    actionOnAccept,
    acceptButtonText,
    actionOnCancel = () => { },
  }) => ({ title, text, text2, visible: true, actionOnAccept, acceptButtonText, noShowButtonBack, actionOnCancel, text3 })),
  on(modalHide, (state: State) => ({ ...state, visible: false })),
);

export function modalReducer(state: typeof initialState = initialState, action: Action) {
  return _modalReducer(state, action);
}
